import styled from "styled-components";
import { Col, Row } from "@viagogo/core/ui";
import { useAppContext } from "src/shared/context/AppContext";
import { EmailSignUp } from "src/website-apps/shared/components/email-signup";

const VerticalMarginRow = styled(Row)`
  margin-top: ${(props) => props.theme.spacing(12)};
  margin-bottom: ${(props) => (props.withBottomMargin ? props.theme.spacing(12) : 0)};
`;

/**
 * Wrapper for EmailSignUp on the Find Experience
 */
export const FindEmailSignUp = ({ privacyPolicyMessage }) => {
  const appContext = useAppContext();

  return (
    <VerticalMarginRow withBottomMargin>
      {!appContext.isNativeApp && (
        <Col span={[12]}>
          <EmailSignUp emailPrivacyDisclosureSiteMessage={privacyPolicyMessage} />
        </Col>
      )}
    </VerticalMarginRow>
  );
};
